import type { ReactNode } from "react";
import classes from "./SearchRelatedResults.module.less";
import classnames from "classnames";

interface SearchItemProps {
  className?: string;
  content: ReactNode;
  title: string;
}

const SearchItem = ({ content, title, className }: SearchItemProps) => {
  return (
    <div className={classnames(className, classes.suggestionsContainer)}>
      <span className={classes.suggestionsTitle}>{title}</span>
      {content}
    </div>
  );
};

export default SearchItem;
